<div mat-dialog-content>

    <mat-card class="trinta-card">
        <h1 class="text-2xl font-extrabold text-gray-900" style="color: var(--darkColor)">Contacto</h1>

        <mat-spinner *ngIf="isLoading"></mat-spinner>
    
        <mat-card-content class="mt-5 w-full" *ngIf="!isLoading">
            <form [formGroup]="contactForm" class="mt-5 w-full">
                <label class="label d-block fw-medium mb-10">
                    Asunto
                </label>
                <mat-form-field>
                    <i-feather name="edit-3"></i-feather>
                    <input matInput placeholder="Asunto" formControlName="asunto">
                    <mat-error *ngIf="!contactForm.get('asunto')?.valid && contactForm.get('asunto')?.touched">Ingrese un asunto</mat-error>
                </mat-form-field>
                <label class="label d-block fw-medium mb-10">
                    Descripción
                </label>
                <mat-form-field class="textarea w-full mb-4">
                    <i-feather name="file-text"></i-feather>
                    <textarea matInput placeholder="Descripción" formControlName="texto"></textarea>
                    <mat-error *ngIf="!this.contactForm.get('texto')?.valid && this.contactForm.get('texto')?.touched">Ingrese una descripción</mat-error>
                </mat-form-field>
            </form>
        </mat-card-content>
    
        <div mat-dialog-actions class="mt-0 flex flex-nowrap justify-end space-x-3" style="justify-content: end;" *ngIf="!isLoading">
            <button mat-button color="primary" (click)="onNoClick()">
                Cancelar
            </button>
            <button mat-flat-button color="primary" cdkFocusInitial (click)="enviar()" [disabled]="contactForm.invalid">
                Enviar
            </button>
        </div>
    </mat-card>
</div>
